/**
 * Geo <-> Grundriss.
 *
 * Ueber die paar hundert Meter, um die es bei einem Objekt geht, reicht eine
 * lokale Tangentialebene. Statt eines pauschalen Erdradius werden die beiden
 * Kruemmungsradien des WGS84-Ellipsoids am Bezugspunkt verwendet — das kostet
 * drei Zeilen und haelt den Fehler im Millimeterbereich, statt ihn auf 200 m
 * auf einige Zentimeter laufen zu lassen.
 *
 * Der Bezugspunkt gehoert zur Flaeche und wird mit ihr gespeichert. Ohne ihn
 * sind die metrischen Koordinaten bedeutungslos.
 */
import { gradInBogen, bogenInGrad } from './typen.js';
/** Grosse Halbachse WGS84. */
const A = 6378137.0;
/** Erste numerische Exzentrizitaet zum Quadrat. */
const E2 = 6.69437999014e-3;
function kruemmung(latGrad) {
    const lat = gradInBogen(latGrad);
    const sin2 = Math.sin(lat) ** 2;
    const w = Math.sqrt(1 - E2 * sin2);
    return {
        m: (A * (1 - E2)) / w ** 3,
        n: (A / w) * Math.cos(lat),
    };
}
/** Mittelpunkt einer Punktwolke — taugt als Bezugspunkt. */
export function bezugspunkt(punkte) {
    if (punkte.length === 0)
        throw new Error('bezugspunkt: keine Punkte');
    let lat = 0;
    let lng = 0;
    for (const p of punkte) {
        lat += p.lat;
        lng += p.lng;
    }
    return { lat: lat / punkte.length, lng: lng / punkte.length };
}
export function nachGrundriss(p, bezug) {
    const k = kruemmung(bezug.lat);
    return {
        x: gradInBogen(p.lng - bezug.lng) * k.n,
        y: gradInBogen(p.lat - bezug.lat) * k.m,
    };
}
export function nachGeo(p, bezug) {
    const k = kruemmung(bezug.lat);
    return {
        lat: bezug.lat + bogenInGrad(p.y / k.m),
        lng: bezug.lng + bogenInGrad(p.x / k.n),
    };
}
export function ringNachGrundriss(ring, bezug) {
    return ring.map((p) => nachGrundriss(p, bezug));
}
export function ringNachGeo(ring, bezug) {
    return ring.map((p) => nachGeo(p, bezug));
}
//# sourceMappingURL=koordinaten.js.map